import React from 'react';

const GOOGLE_REVIEWS_URL =
  'https://www.google.com/search?q=SwiftMaze+Tech+Pvt+Ltd+Modasa+reviews';
const CLUTCH_REVIEW_URL =
  'https://review.clutch.co/review?provider_id=56ee2257-be27-4a0f-9594-e6df1b0479e6';

const ReviewPlatforms = () => (
  <section className="home-reviews-section" aria-labelledby="home-reviews-title">
    <div className="auto-container">
      <div className="sec-title centered">
        <div className="title">INDEPENDENT CUSTOMER FEEDBACK</div>
        <h2 id="home-reviews-title">Read Our Customer Reviews</h2>
        <div className="text">
          Read customer feedback or share your experience with SwiftMaze on an independent review platform.
        </div>
      </div>

      <div className="home-review-platforms">
        <article className="home-review-platform home-review-platform--google">
          <div className="home-review-platform-head">
            <span className="home-review-brand-mark">
              <img src="/assets/images/reviews/google-g.png" alt="Google logo" loading="lazy" />
            </span>
            <div>
              <span className="home-review-label">Available now</span>
              <h3>Google Reviews</h3>
            </div>
          </div>
          <div className="home-review-stars" aria-label="Customer reviews on Google">
            <i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star"></i>
            <i className="fa fa-star"></i><i className="fa fa-star"></i>
          </div>
          <p>See feedback shared by customers on the SwiftMaze Google Business profile.</p>
          <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer nofollow">
            Read Google Reviews <i className="fa fa-external-link" aria-hidden="true"></i>
          </a>
        </article>

        <article className="home-review-platform home-review-platform--clutch">
          <div className="home-review-platform-head">
            <span className="home-review-brand-mark">
              <img src="/assets/images/reviews/clutch.png" alt="Clutch logo" loading="lazy" />
            </span>
            <div>
              <span className="home-review-label">Available now</span>
              <h3>Clutch Reviews</h3>
            </div>
          </div>
          <div className="home-review-placeholder" aria-hidden="true">
            <i className="fa fa-pencil-square-o"></i>
          </div>
          <p>Worked with SwiftMaze? Share your project experience through our Clutch review form.</p>
          <a href={CLUTCH_REVIEW_URL} target="_blank" rel="noopener noreferrer nofollow">
            Review Us on Clutch <i className="fa fa-external-link" aria-hidden="true"></i>
          </a>
        </article>
      </div>
    </div>
  </section>
);

export default ReviewPlatforms;
